import { defineComponent as _defineComponent } from 'vue'
import {
    computed,
    reactive,
    ref,
    onMounted,
  } from "vue";
  import Cleave from "vue-cleave-component";
  import ToggleButton from "@/components/ui/ToggleButton.vue";
  import Modal from "@/components/ui/Modal.vue";
  import useVuelidate from "@vuelidate/core";
  import { required, minValue } from "@vuelidate/validators";
  import { useStore } from "vuex";
  import { EstateInterface } from "@/types/EstateInterface";

  const tooltipText =
    "To connect a trust account and start accepting deposits for this project, please contact Customer Support.";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EditInitialDepositModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update", "close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const emits = __emit;
  const props = __props;

  const disabled = ref(false);
  const loading = ref(true);
  const initDepositCondition = ref(true);
  const initDepositOptions = {
    numeral: true,
    numeralThousandsGroupStyle: "thousand",
    prefix: "$",
    rawValueTrimPrefix: true,
  };
  const isTrustAccountConnected = ref(false);
  const form = reactive<Partial<EstateInterface>>({
    isRefundable: true,
    initDeposit: 0,
  });

  const getMinDepositValue = computed(() => {
    return initDepositCondition.value ? 1 : 0;
  });

  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  const rules = computed(() => {
    return {
      initDeposit: {
        required,
        minValue: minValue(getMinDepositValue.value),
      },
    };
  });
  const v$ = useVuelidate(rules, form);

  onMounted(() => {
    store
      .dispatch("estate/getEstate", estateId.value)
      .then((res) => {
        form.isRefundable = res.data.isRefundable;
        form.initDeposit = res.data.initDeposit / 100;
        isTrustAccountConnected.value = res.data.lawyerId;

        if (form.initDeposit > 0) {
          initDepositCondition.value = true;
        } else {
          initDepositCondition.value = false;
        }
      })
      .finally(() => {
        loading.value = false;
      });
  });

  const setDepositAndRefundable = () => {
    if (initDepositCondition.value) {
      form.isRefundable = true;
    } else {
      form.initDeposit = 0;
      form.isRefundable = false;
    }
  };

  const save = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) {
      return;
    }

    loading.value = true;
    store
      .dispatch("estate/updateEstate", {
        id: estateId.value,
        data: {
          initDeposit: form.initDeposit * 100,
          isRefundable: form.isRefundable,
        },
      })
      .finally(() => {
        loading.value = false;
        emits("close");
      });
  };

const __returned__ = { store, emits, props, disabled, loading, initDepositCondition, initDepositOptions, isTrustAccountConnected, tooltipText, form, getMinDepositValue, estateId, rules, v$, setDepositAndRefundable, save, computed, reactive, ref, onMounted, get Cleave() { return Cleave }, ToggleButton, Modal, get useVuelidate() { return useVuelidate }, get required() { return required }, get minValue() { return minValue }, get useStore() { return useStore }, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})